import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const { googleSession } = useAuth();
  const nav = useNavigate();
  const location = useLocation();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match?.[1];
    if (!sessionId) { nav("/login", { replace: true }); return; }
    (async () => {
      try {
        const u = await googleSession(sessionId);
        toast.success(`Welcome, ${u.name.split(" ")[0]}`);
        const dest =
          u.role === "admin" ? "/admin"
          : u.role === "doctor" ? "/doctor"
          : u.role === "partner" ? "/partner"
          : u.role === "driver" ? "/driver"
          : u.role === "field_executive" ? "/field"
          : "/patient";
        nav(dest, { replace: true, state: { user: u } });
      } catch (e) {
        toast.error(e?.response?.data?.detail || "Google sign-in failed");
        nav("/login", { replace: true });
      }
    })();
  }, []);

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center gap-3" data-testid="auth-callback">
      <div className="w-10 h-10 border-4 border-teal-600 border-t-transparent rounded-full animate-spin" />
      <div className="text-slate-600 text-sm">Completing Google sign-in…</div>
    </div>
  );
}
